import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export class ImageCarousel {

	el: HTMLElement
	// @ts-ignore
	swiper: Swiper
	nextEl: HTMLElement
	prevEl: HTMLElement
	paginationEl: HTMLElement
    
	constructor(el) {
		this.el = el.querySelector('.swiper')
    this.nextEl = el.querySelector('.swiper-custom-button-next')
    this.prevEl = el.querySelector('.swiper-custom-button-prev')
    this.paginationEl = el.querySelector('.swiper-pagination')
		this.init()
	}

	init() {
		this.swiper = new Swiper(this.el, {
			modules: [Navigation, Pagination],
			speed: 500,
			slidesPerView: 1,
      spaceBetween: 24,
			allowTouchMove: true,
			navigation: {
				nextEl: this.nextEl,
				prevEl: this.prevEl,
			},
			pagination: {
        type: 'fraction',
				el: this.paginationEl
			},
      on: {
        afterInit: (swiper) => { this.videoPlayPause(swiper) },
        slideChange: (swiper) => { this.videoPlayPause(swiper) },
      }
		})
	}

  videoPlayPause(swiper:Swiper) {
    const previousSlide = swiper.slides[swiper.previousIndex]
    const activeSlide = swiper.slides[swiper.activeIndex]

    if (previousSlide) {
      const previousVideo = previousSlide.querySelector('video')
      if (previousVideo) { 
        previousVideo.pause() 
        previousVideo.currentTime = 0
      }
    }

    const activeVideo = activeSlide.querySelector('video')
    
    if (activeVideo) { 
      activeVideo.currentTime = 0
      activeVideo.play() 
    }
  }
}